import { render, staticRenderFns } from "./StudentsDropdown.vue?vue&type=template&id=413ff95f&"
import script from "./StudentsDropdown.vue?vue&type=script&lang=ts&"
export * from "./StudentsDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports